export class TopicDto {
    id!: number;
    playerName!: string;
    playerId!: number;
    title!: string;
    text!: string;
    createdAt!: string;
    editedAt!: string;
    editorName!: string;
    rate!: number;
    myVote!: number;
    tags!: Tag[];
    canEdit!: boolean;
    guest!: boolean;
    pinned!: boolean;
    admin!:boolean;
    moder!:boolean;
    commentsReadTillPage!: number;
}

export enum Tag {
    NEWS = 'NEWS',
    SUGGESTIONS = 'SUGGESTIONS',
    GAME_DISCUSSIONS = 'GAME_DISCUSSIONS',
    TALK = 'TALK',
    PLAY = 'PLAY',
    HELP = 'HELP',
    QUESTIONS = 'QUESTIONS',
    MEET = 'MEET',
    COMPETITION = 'COMPETITION',
    RULES = 'RULES',
    CLAN_INFO = 'CLAN_INFO',
    CLAN_STUFF = 'CLAN_STUFF',
    CLAN_TALK = 'CLAN_TALK',
    CLAN_OTHER = 'CLAN_OTHER',
    CHRONICLES = 'CHRONICLES'
}

export enum ForumTab {
    TOP = 'TOP',
    NEW = 'NEW'
}

export enum ForumFilter {
    DAY = 'DAY',
    WEEK = 'WEEK',
    ALL_TIME = 'ALL_TIME'
}

export class ForumDto {
    tab!: ForumTab;
    filter!: ForumFilter;
    topics!: TopicDto[];
    pageCurr!: number;
    pageMax!: number;
    availableTags!: Tag[];
    selectedTags!: Tag[];
    headTags!: Tag[];
    canCreateTopic!: boolean;
    canCreateGuestTopic!: boolean;
}

export class ForumRequestBody {
    tags!: Tag[];
    forumTab!: ForumTab;
    forumFilter!: ForumFilter;
    page!: number;
}

export class TopicBody {
    title!: string;
    text!: string;
    tags!: Tag[];
    guest!: boolean;
}

export class CommentBody {
    topicId!: number;
    text!: string;
}

export class CommentDto {
    id!: number;
    topicId!: number;
    playerName!: string;
    playerId!: number;
    text!: string;
    createdAt!: string;
    editedAt!: string;
    editorName!: string;
    rate!: number;
    myVote!: number;
    canEdit!: boolean;
    admin!:boolean;
}

export class CommentsDto {
    topic!: TopicDto;
    comments!: CommentDto[];
    pageCurr!: number;
    pageMax!: number;
    canCreateComment!: boolean;
}
